import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Paper, Typography, Box, Alert, CircularProgress } from '@mui/material';
import { selectApplications, fetchApplications } from '../store';
import { useAppDispatch } from '../store/hooks';

const ApplicationStatus: React.FC = () => {
  const dispatch = useAppDispatch();
  const applications = useSelector(selectApplications);
  
  // Fetch applications when component mounts
  useEffect(() => {
    dispatch(fetchApplications());
  }, [dispatch]);
  
  if (!Array.isArray(applications) || applications.length === 0) {
    return (
      <Paper elevation={3} sx={{ p: 4, maxWidth: 800, mx: 'auto', mt: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Application Status
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress size={40} />
          <Typography variant="body1" color="text.secondary">
            Loading applications...
          </Typography>
        </Box>
      </Paper>
    );
  }

  const latestApplication = applications[applications.length - 1];

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 800, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Application Status
      </Typography>
      <Alert 
        severity={latestApplication.status === 'approved' ? 'success' : latestApplication.status === 'rejected' ? 'error' : 'info'}
      >
        Your application is {latestApplication.status}.
      </Alert>
      <Box sx={{ mt: 3 }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
            <Box sx={{ flex: '1 1 300px', minWidth: '250px' }}>
                <Typography variant="h6" sx={{ mb: 1, color: '#1e293b' }}>Application ID:</Typography>
                <Typography sx={{ fontFamily: 'monospace', fontSize: '0.9rem', color: '#64748b' }}>{latestApplication.id}</Typography>
            </Box>
            <Box sx={{ flex: '1 1 300px', minWidth: '250px' }}>
                <Typography variant="h6" sx={{ mb: 1, color: '#1e293b' }}>Applicant Name:</Typography>
                <Typography sx={{ fontSize: '1rem', color: '#374151' }}>{latestApplication.applicantName}</Typography>
            </Box>
            <Box sx={{ flex: '1 1 300px', minWidth: '250px' }}>
                <Typography variant="h6" sx={{ mb: 1, color: '#1e293b' }}>Final Score:</Typography>
                <Typography sx={{ fontSize: '1.1rem', fontWeight: 600, color: '#059669' }}>{latestApplication.creditScore}</Typography>
            </Box>
            {latestApplication.status === 'approved' && latestApplication.interestRate && (
                 <Box sx={{ flex: '1 1 300px', minWidth: '250px' }}>
                    <Typography variant="h6" sx={{ mb: 1, color: '#1e293b' }}>Interest Rate:</Typography>
                    <Typography sx={{ fontSize: '1rem', color: '#dc2626', fontWeight: 600 }}>{latestApplication.interestRate}%</Typography>
                </Box>
            )}
        </Box>
      </Box>
    </Paper>
  );
};

export default ApplicationStatus; 